import { makeStyles } from '@material-ui/styles'
import { Theme } from 'styling/theme'

export default makeStyles((theme: Theme) => ({
    close: {
        ...theme.modalClose,
    },
    paper: {
        '@media (max-width: 767px)': {
            width: 320,
        },
    },
    tvPaper: {
        maxWidth: '100%',
        width: '100%',
        height: '100%',
        maxHeight: '100%',
        border: 'none',
        borderRadius: 0,

        '& > div:last-child': {
            width: '100%',
            height: 'initial',
            overflowX: 'initial',
            overflowY: 'initial',
        },
    },
    tvRoot: {
        position: 'relative',
        height: '100vh',

        '& > div': {
            position: 'relative !important',
            display: 'block',
        },
    },
}))
